module.exports = __webpack_public_path__ + "static/img/de.183b0b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/de.svg
// module id = hkB+
// module chunks = 4